/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import LoadingOverlay from "../../../../common/LoadingBar.js";
import loader from "../../../../../assets/Image/Loader2.gif";

const SalesInvoiceTable = ({
    data = [],
    columns,
    showAction,
    showFooter,
    onEdit,
    onDelete,
    showNo = true,
    showExport,
    showFilter,
    handlePrint,
    loading,
    currentPage: externalCurrentPage,
    totalCount: externalTotalCount,
    totalPages: externalTotalPages,
    onPageChange,
    searchTerm: externalSearchTerm,
    onSearch,
}) => {
    const [currentPage, setCurrentPage] = useState(externalCurrentPage || 1);
    const [searchTerm, setSearchTerm] = useState(externalSearchTerm || "");
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const totalPages = externalTotalPages || Math.ceil(data.length / rowsPerPage);

    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: "ascending",
    });

    const getDisplayedData = () => {
        if (externalTotalPages) {
            return data;
        }
        const startIndex = (currentPage - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        return data.slice(startIndex, endIndex);
    };

    const filterData = (dataToFilter) => {
        if (!searchTerm) return dataToFilter;
        return dataToFilter.filter((item) =>
            Object.values(item).some((value) =>
                String(value).toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    };

    const sortDisplayedData = (dataToSort) => {
        let sortableItems = [...dataToSort];
        if (sortConfig.key) {
            sortableItems.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === "ascending" ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === "ascending" ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableItems;
    };




    const handleSearchChange = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        if (onSearch) {
            onSearch(term);
        }
    };

    const handlePageClick = (page) => {
        setCurrentPage(page);
        if (onPageChange) {
            onPageChange(page);
        }
    };

    const displayedData = getDisplayedData();
    const filteredData = filterData(displayedData);
    const sortedDisplayedData = sortDisplayedData(filteredData);


    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };

    const renderPagination = () => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(
                <li
                    key={i}
                    className={`page-item ${currentPage === i ? "active" : "pgbtn"}`}
                >
                    <a
                        className="page-link"
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageClick(i);
                        }}
                    >
                        {i}
                    </a>
                </li>
            );
        }
        return pages;
    };


    const statusStyles = {
        enable: {
            backgroundColor: "#6CBE1C", // Green background for Enable
            color: "#fff",
            borderRadius: "30px",
            padding: "5px 10px",
        },
        disable: {
            backgroundColor: "#F6F6F6", // Red background for Disable
            color: "#fff",
            borderRadius: "30px",
            padding: "5px 10px",
        },
        draft: {
            backgroundColor: "#D1D1EF",
            color: "#fff",
            borderRadius: "30px",
            padding: "5px 10px",
        },
        unpaid: {
            backgroundColor: "#EF3E49",
            color: "#fff",
            borderRadius: "30px",
            padding: "5px 10px",
        },
        paid: {
            backgroundColor: "#5856AC",
            color: "#fff",
            borderRadius: "30px",
            padding: "5px 10px",
        },
    };



    if (loading) {
        return (
      <LoadingOverlay loading={loading} loader={loader} />
        );
    }

    return (
        <div className="data-table-container">
            <div className="d-flex mb-3 mt-3">
                <div className="expense-searchcontainerstart d-flex">
                    <div className="search-container">
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            placeholder="Search"
                            style={{ height: "40px", backgroundColor: "#fff", border: '1px solid #DBDBDB', boxShadow: "0px 0px 10px rgba(187, 187, 187, 0.25)" }}
                        />
                        <svg
                            className="search-container-icon"
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10.5416 19.2497C15.3511 19.2497 19.2499 15.3508 19.2499 10.5413C19.2499 5.73186 15.3511 1.83301 10.5416 1.83301C5.73211 1.83301 1.83325 5.73186 1.83325 10.5413C1.83325 15.3508 5.73211 19.2497 10.5416 19.2497Z"
                                stroke="#292D32"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M20.1666 20.1663L18.3333 18.333"
                                stroke="#292D32"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>

                </div>
                <div >

                    {/* <div
                        className="expense-search d-flex align-items-center"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#FFFFFF",
                            border: "1px solid #DBDBDB",
                            borderRadius: "10px",
                            cursor: "pointer",
                            width: "180px",
                            height: "40px"

                        }}
                    >
                        <span
                            style={{
                                fontStyle: "normal",
                                fontWeight: "800",
                                fontSize: "14px", // Compact text
                                color: "#000000",
                                marginLeft: "18px",

                            }}
                        >
                            Show Rows:
                        </span>
                        <select
                            name="option"
                            id="pageSelect"
                            className="selectoptions"
                            style={{
                                backgroundColor: "#282E26", // Match background color
                                color: "#FFFFFF", // White text color
                                
                                fontStyle: "normal",
                                fontWeight: "700",
                                fontSize: "14px",
                                lineHeight: "16px",
                                padding: "4px 6px", // Adjust padding for the dropdown
                                border: "none", // No border
                                borderRadius: "0 10px 10px 0", // Rounded on the right side only
                                cursor: "pointer",
                                height: "40px",
                                marginLeft: "auto", // Push to the right
                            }}
                            value={rowsPerPage}
                            onChange={(e) => {
                                setRowsPerPage(Number(e.target.value));
                                setCurrentPage(1); // Reset to the first page on change
                            }}
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={15}>15</option>
                            <option value={20}>20</option>
                        </select>
                    </div> */}
                </div>
            </div>

            <table className="data-table custom-table" style={{
                borderRadius: "20px 20px 0 0",
                border: "1px solid #EBEAF2",
                borderCollapse: "separate",
                borderSpacing: 0,
                overflow: "hidden"
            }} >
               <thead className="table-header">
  <tr>
    {showNo && <th>No</th>}

    {columns.map((col, index) => (
      <th key={index} onClick={() => handleSort(col.field)}>
        {col.header}
      </th>
    ))}

    {showAction && <th>Action</th>}
  </tr>
</thead>

              <tbody className="table-body">
  {sortedDisplayedData.length === 0 ? (
    <tr>
      <td
        colSpan={
          columns.length +
          (showNo ? 1 : 0) +
          (showAction ? 1 : 0)
        }
        style={{
          textAlign: "center",
          fontWeight: 600,
          fontSize: "24px",
        }}
      >
        No data found
      </td>
    </tr>
  ) : (
    sortedDisplayedData.map((item, index) => (
      <tr key={item.id || index}>
        {showNo && (
          <td>
            {(externalCurrentPage - 1) * 10 + index + 1}
          </td>
        )}

        {columns.map((col, colIndex) => (
          <td key={colIndex}>
            {col.render ? col.render(item) : (item[col.field] ?? "-")}
              {/* {item[col.field] ?? "-"} */}
          </td>
        ))}

        {showAction && <td className="action-column">...</td>}
      </tr>
    ))
  )}
</tbody>


            </table>
            {showFooter && (
                <nav>
                    <ul className="pagination">

                        {renderPagination()}

                    </ul>
                </nav>
            )}
        </div>
    );
};

export default SalesInvoiceTable;
